module.exports = __webpack_public_path__ + "img/_1.6929c23b.png";